import React, { useEffect, useRef, useState } from 'react';
import './App.css';
import { Button, Input, InputRef } from 'antd';
import axios from 'axios';
import useMessage from 'antd/es/message/useMessage';

export const bebas = 'Bebas Neue';

const {TextArea} = Input;

function App() {

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [header, setHeader] = useState("App Support");

  const [messageAPI, contextHolder] = useMessage();

  const processPath = (path: string): string => {
    try {
      const appName = path.split("/")[2].replaceAll("-", " ");
      if (appName.trim() === "") {
        throw new Error("Name empty");
      }
      return appName;
    } catch (err: any) {
      window.location.href = 'https://www.sarbzone.com';
      return "";
    }
  };

  const validateEmail = (email: string) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const checkValidity = () => {

    if (name.trim() === "") {
      messageAPI.error("Your Name Can't be Blank😬");
      return false;
    } 

    if (!validateEmail(email)) {
      messageAPI.error("Email is invalid😬");
      return false;
    }

    if (message.trim() === "") {
      messageAPI.error("Message can't be Blank😬");
      return false;
    }

    return true;

    
  };

  const sendMessage = () => {
    const isValid = checkValidity();
    if (isValid) {
      axios
        .post("/sendMessage", {
          name,
          message,
          email,
        })
        .then((res) => {
          if (res.data === "success") {
            setName("");
            setEmail("");
            setMessage("");
            messageAPI.success("Message Sent..");
            messageAPI.info('We will reach you shortly');
          } else {

            messageAPI.error("Something Went Wrong... Try Again Later");
          }
        })
        .catch((err) => {
          console.log(err.message);
          messageAPI.error(err.message);

        });
    }
  };

  const clearFields = () => {
    setName("");
    setEmail("");
    setMessage("");
  };

  useEffect(() => {
    const path = window.location.pathname;

    setHeader(processPath(path));
  }, []);

  return (
   <div>
   {contextHolder}
    <div style={{display:'flex', fontSize:25, fontFamily:bebas, justifyContent:'center', color:'white', padding:10, backgroundColor:'black' }}>
      SARBZONE
    </div>
    <div style={{display:'flex', fontSize:25, fontFamily:bebas, margin:20, justifyContent:'center', }}>
      iOS App Support for {header}
    </div>
    <div style={{display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center'}}>

<Input onChange={(e)=>{setName(e.target.value)}} placeholder='Your Name' value={name} style={{maxWidth:window.innerWidth>700?400:"95%", margin:10, padding:5}}  />
    <Input onChange={(e)=>{setEmail(e.target.value)}} placeholder='Your Email' value={email} style={{maxWidth:window.innerWidth>700?400:"95%", margin:10, padding:5}}  />
<TextArea onChange={(e)=>{setMessage(e.target.value)}} value={message} placeholder='Write your concern or feedback here...' style={{maxWidth:window.innerWidth>700?400:"95%", margin:10, padding:5, height:200}}  />

    </div>

<div style={{display:'flex', flexDirection:'row', width:window.innerWidth>700?400:window.innerWidth,margin:'auto', justifyContent:'space-around'}}>
<Button onClick={clearFields} >Clear</Button>
<Button onClick={sendMessage} type='primary' >Send</Button>
</div>

<div>

</div>

   </div>
  );
}

export default App;
